import { Send } from "lucide-react";

export const TelegramShareButton = ({ url, text, testId, className = "" }) => {
  const href = `https://t.me/share/url?url=${encodeURIComponent(url)}&text=${encodeURIComponent(text)}`;
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      data-testid={testId}
      className={`inline-flex items-center justify-center gap-2.5 rounded-full border border-nora-mint/30 bg-nora-mint/10 px-8 py-4 font-display text-sm font-bold text-nora-mint transition-colors hover:bg-nora-mint/20 sm:text-base ${className}`}
    >
      <Send className="h-5 w-5" />
      Поделиться в Telegram
    </a>
  );
};
